import React, { useState, useRef, useEffect } from "react";
import Select from "react-select";
import { customSelectStyles } from "../utils/styles";
import items_en from "../data/en/Items.json";
import items_vi from "../data/vi/Items.json";
import { useTranslation } from "react-i18next";
import pkg from "../../package.json";

const webCommandAPI = pkg["web-command-api"];

function HandleItems() {
  const [selectedOption, setSelectedOption] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const [showNotification, setShowNotification] = useState(false);
  const [isExecuting, setIsExecuting] = useState(false);
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [itemsData, setItemsData] = useState([]);

  // Fetch data
  useEffect(() => {
    const fetchItemData = async () => {
      const url =
        currentLanguage === "vi"
          ? "https://raw.githubusercontent.com/arimetson/hotarusr-web-data/refs/heads/main/data/vi/Items.json"
          : "https://raw.githubusercontent.com/arimetson/hotarusr-web-data/refs/heads/main/data/en/Items.json";

      try {
        const res = await fetch(url);
        if (!res.ok) throw new Error("Network response was not ok");
        const json = await res.json();
        setItemsData(json);
      } catch (error) {
        // Fallback to local data
        setItemsData(currentLanguage === "vi" ? items_vi : items_en);
      }
    };

    fetchItemData();
  }, [currentLanguage]);

  const handleSelectChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  const handleQuantityChange = (value) => {
    let newValue = parseInt(value);
    if (isNaN(newValue) || newValue < 1) {
      newValue = 1;
    }
    setQuantity(newValue);
  };

  const inputRef3 = useRef(null);
  const handleInputClick3 = () => {
    if (inputRef3.current) {
      inputRef3.current.select();
      document.execCommand("copy");
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 2000); // Hide notification after 2 seconds
    }
  };

  // Hàm xử lý nút Execute
  const handleExecute = () => {
    if (isExecuting) return;
    setIsExecuting(true);

    try {
      const savedKey = sessionStorage.getItem("playerKey");
      if (!savedKey) return;

      if (!selectedOption) return;

      let commandValue = `/give ${selectedOption.value} x${quantity}`;
      if (commandValue.startsWith("/")) {
        commandValue = commandValue.substring(1);
      }

      const encodedCommand = encodeURIComponent(commandValue);
      const url = `${webCommandAPI}/excute/${savedKey}/${encodedCommand}`;

      fetch(url, { mode: "no-cors" })
        .then((res) => res.text())
        .catch(() => { });
    } catch (_) { }

    setTimeout(() => {
      setIsExecuting(false);
    }, 5000);
  };

  const handleFocusAndClick = (e) => {
    e.target.select();
  };

  return (
    <>
      <div className="body">
        <div className="row">
          <div className="col-sm-1" />
          <div className="col-sm-3">
            <h2 className="title">{t("items")}</h2>
          </div>
          <div className="col-sm-8" />
        </div>
      </div>
      <div className="body">
        <div className="row">
          <div className="col-sm-1" />
          <div className="col-sm-10">
            <div
              className="outdated-message"
              dangerouslySetInnerHTML={{ __html: t("beta-warning-message") }}
            />
          </div>
          <div className="col-sm-1"></div>
        </div>
      </div>
      <br />
      <div className="body">
        <div className="row">
          <div className="col-sm-1" />
          <div className="col-sm-2">
            <h5 className="name-of-selection">{t("items-name")}</h5>
          </div>
          <div className="col-sm-6">
            <Select styles={customSelectStyles}
              className="select"
              value={selectedOption}
              onChange={handleSelectChange}
              options={itemsData.map((items) => ({
                value: items.id,
                label: items.name,
              }))}
            />
          </div>
          <div className="col-sm-3" />
        </div>
      </div>
      <br />
      <div className="body">
        <div className="row">
          <div className="col-sm-1" />
          <div className="col-sm-2">
            <h5 className="name-of-selection">{t("quantity")}</h5>
          </div>
          <div className="col-sm-6">
            <input
              type="number"
              value={quantity}
              onChange={(e) => handleQuantityChange(e.target.value)}
              className="glass-input"
              onClick={handleFocusAndClick}
              onFocus={handleFocusAndClick}
            />
          </div>
          <div className="col-sm-3" />
        </div>
      </div>
      <br />
      <div className="body">
        <div className="row">
          <div className="col-sm-1" />
          <div className="col-sm-2">
            <h2 className="final-command">{t("command")}</h2>
          </div>
          <div className="col-sm-3" />
        </div>
      </div>
      <div className="body">
        <div className="row">
          <div className="col-sm-1" />
          <div className="col-sm-6">
            {selectedOption && (
              <input
                type="text"
                value={`/give ${selectedOption.value} x${quantity}`}
                readOnly
                ref={inputRef3}
                className="glass-input"
                onClick={handleInputClick3}
                onFocus={handleFocusAndClick}
              />
            )}
          </div>
          {selectedOption && (
            <div className="col-sm-2">
              <button
                className="glass-button-primary w-full"
                onClick={handleExecute}
                disabled={isExecuting}
              >
                {isExecuting ? "Executing..." : "Execute"}
              </button>
            </div>
          )}
          <div className="col-sm-5" />
        </div>
      </div>
      {showNotification && (
        <div className="notification">{t("copySuccess")}</div>
      )}
      <div style={{ marginTop: "100px" }} />
    </>
  );
}

export default HandleItems;
